import PrinterHistory from "@/views/admin/printer/PrinterHistory";

export default {
  path: "logs/printer-history",
  name: "logs-printer-history",
  component: PrinterHistory,
  props: true,
  meta: {
    requiresAuth: true,
    owner: true
  }
};
